import { render, staticRenderFns } from "./modalInfoExame.vue?vue&type=template&id=73ebda1a&"
import script from "./modalInfoExame.vue?vue&type=script&lang=js&"
export * from "./modalInfoExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports